export const UNAVAILABLE_STATUS = 503
export const PAYMENT_REQUIRED_STATUS = 402
